import { pushAdClickToDataLayer } from './click_tracking'

export const handleAdClick = (event) => {
  const clickFromAd = event.origin.endsWith('safeframe.googlesyndication.com')

  if (!clickFromAd || !window.googleAdIframes) {
    return;
  }

  const matchedIframe = window.googleAdIframes.find((iframe) => {
    return event.source.window === iframe.contentWindow;
  });

  if (matchedIframe) {
    const parentElement = matchedIframe.parentElement.parentElement;
    const clickDataElement = parentElement.getElementsByClassName('click_data_element')[0];
    Object.assign(clickDataElement.dataset, event.data.dataset);
    clickDataElement.innerText = event.data.text;

    pushAdClickToDataLayer(clickDataElement, new URL(event.data.href).searchParams.get('adurl'));
  }
}
